export const iconFontAwesomeFoodBeverageMartiniGlassEmpty = (
	<i className="fa-solid fa-martini-glass-empty"></i>
);
